var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0475 0H10.9525C4.90362 0 0 4.90362 0 10.9525V29.0475C0 35.0964 4.90362 40 10.9525 40H29.0475C35.0964 40 40 35.0964 40 29.0475V10.9525C40 4.90362 35.0964 0 29.0475 0Z",
    fill: "url(#paint0_radial_18232_96073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3534 20.7756C17.8201 20.7622 17.2866 20.7924 16.7583 20.866C15.9917 21.0385 15.3195 21.4962 14.8781 22.1463C14.4368 22.7964 14.2593 23.59 14.3818 24.3662C14.4973 25.1503 14.9063 25.8614 15.5262 26.3553C16.146 26.8493 16.9304 27.0893 17.7205 27.0268C18.499 26.9731 19.2284 26.6271 19.7625 26.0582C20.2967 25.4894 20.5961 24.7397 20.6007 23.9593C20.6007 19.2064 20.6007 14.4598 20.6007 9.70684V9.20312H24.3011C24.5336 12.3481 26.3805 13.9497 29.4028 14.3694V17.9923C27.5931 17.9698 25.8335 17.3952 24.3592 16.3455C24.3592 16.5134 24.3592 16.6361 24.3592 16.7588C24.3592 19.0901 24.3592 21.4149 24.3592 23.7398C24.4078 25.1814 23.994 26.6009 23.1784 27.7906C22.3628 28.9804 21.188 29.8781 19.8258 30.3526C18.5869 30.8597 17.2211 30.9693 15.9172 30.6661C14.6134 30.363 13.4359 29.6622 12.5478 28.6607C11.5955 27.7394 10.9497 26.5476 10.6978 25.2468C10.446 23.946 10.6003 22.5992 11.14 21.3891C11.6872 19.9936 12.6806 18.8182 13.9655 18.0461C15.2504 17.2741 16.7545 16.9486 18.2436 17.1205L18.3792 17.1528L18.3534 20.7756Z",
    fill: "url(#paint1_linear_18232_96073)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18232_96073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4927 -17.9335) scale(35.3051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#232222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2D2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18232_96073",
    x1: 20.0002,
    y1: 30.7982,
    x2: 20.0002,
    y2: 9.20312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DEE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.516fd961e1fd116e7364dbcab4e7cded.svg";
export { ForwardRef as ReactComponent };